<aside>
  <div class="c__items">
    @for (row of arrRows; track i; let i = $index) {
      <div #itemsRow
        class="c__items-row {{_showedRow >= (i + 1) ? 'is-visible' : ''}}"
        [@expandCollapse]="_showedRow >= (i + 1) ? '1' : '0'"
      >
        @for (item of items | slice: (i*itemsPerRow):(i+1)*itemsPerRow; track j; let j = $index) {
          <div #itemsElement class="c__item">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
          </div>
        }
      </div>
    }
  </div>

  @if ((isLazyLoading && showButton) || (_showedRow < rowNumber) || (dynamicContentShowMore?.isActive && !dynamicContentShowMore?.isLast)) {
    <button sd-button [brand]="brand" type="button" class="c__action is-show-more" (click)="manageShowMore()">
      @if (!customButtonTitle) {
        {{ 'actions.showMore' | translate }}
      }
      @if (customButtonTitle) {
        {{customButtonTitle}}
      }
      @if (context) {
        <span class="is-visually-hidden"> - {{ context }}</span>
      }
    </button>
  }

  @if (showLessButton && (_showedRow === rowNumber || (!dynamicContentShowMore?.isActive && dynamicContentShowMore?.isLast))) {
    <button sd-button [brand]="brand" type="button" class="c__action is-show-less" (click)="showLess()">
      {{ 'actions.showLess' | translate }}
      @if (context) {
        <span class="is-visually-hidden"> - {{ context }}</span>
      }
    </button>
  }
</aside>
